/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, isCustomerSelect } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var base64 = require("base-64");
var module = "broadcast";
var moduleName = "Broadcast(Whatsapp Message)";
var modulePath = "/clientpanel/broadcast";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        broadcastTitle: "",
        whatsappTemplate: "",
        broadcastSchedule: "",
        selectedCustomer: [],
        status: "",
        customersfromsegment: "No",
        customersegmentId: "",
        broadcastMsgStatus: "Pending",
        action: "add",
      },
      loading: true,
      formpost: [],
      companyDetail: [],
      customerList: [],
      customersegmentList: [],
      templateDetail: {},
    };
  }
  componentDidMount() {
    this.loadCustomers();
    this.loadWhatsappTemplate();
    this.loadCustomerSegment();
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: apiUrl + module + "/details/" + this.state.editID,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var broadcastStatus = result.broadcastStatus == "A" ? "Active" : "Inactive";
          var status =
            result.broadcastStatus !== "" && result.broadcastStatus !== null
              ? {
                  label: broadcastStatus,
                  value: result.broadcastStatus,
                }
              : "";
          var clientupdatedata = {
            broadcastTitle: result.broadcastTitle,
            selectedCustomer: result.selectedCustomer,
            broadcastSchedule: result.broadcastSchedule !== null && result.broadcastSchedule !== "" ? new Date(result.broadcastSchedule) : "",
            whatsappTemplate: result.broadcastTemplateID,
            broadcastMsgStatus: result.broadcastMsgStatus,
            status: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false }, () => {
            if (result.broadcastTemplateID.value != "" && result.broadcastTemplateID.value != undefined) {
              this.getTemplateDetail(result.broadcastTemplateID.value);
            }
          });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {};

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: value } } }), () => {
      if (field == "whatsappTemplate") {
        this.getTemplateDetail(value.value);
      }
      if (field == "customersegmentId") {
        this.getcustomerSegmentDetail(value.value);
      }
      if (field == "customersfromsegment") {
        this.updateCustList(value);
      }
    });
  };

  updateCustList(fromsegment) {
    if (fromsegment == "Yes") {
      let postdataObjct = this.state.postdata;
      postdataObjct.selectedCustomer = [];
      this.setState({ customerList: [], postdata: postdataObjct, customersegmentId: "" });
    } else if (fromsegment == "No") {
      this.loadCustomers();
    }
  }

  getTemplateDetail(templateId) {
    var urlShringTxt = apiUrl + "whatsapptemplate/details/" + base64.encode(templateId);
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ templateDetail: res.data.result });
      }
    });
  }

  getcustomerSegmentDetail(segmentId) {
    var urlShringTxt = apiUrl + "customeranalytics/analyticgroupcustomers?groupid=" + segmentId;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ customerList: res.data.result });
      } else {
        let customerList = [];
        this.setState({ customerList: customerList });
      }
    });
  }

  loadCustomers() {
    try {
      var urlShringTxt = apiUrl + "customer/dropdownlist";

      axios.get(urlShringTxt, clientheaderconfig).then((res) => {
        if (res.data.status === "ok") {
          let postdataObjct = this.state.postdata;
          postdataObjct.selectedCustomer = [];
          this.setState({ customerList: res.data.result, postdata: postdataObjct, customersegmentId: "" });
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  loadWhatsappTemplate() {
    var urlShringTxt = apiUrl + "whatsapptemplate/dropdownlist";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ whatsappTemplateList: res.data.result });
      }
    });
  }

  loadCustomerSegment() {
    var urlShringTxt = apiUrl + "customeranalytics/dropdownlist";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ customersegmentList: res.data.result });
      }
    });
  }

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    var selectedCustomer = [];
    if (postData.selectedCustomer.length > 0) {
      postData.selectedCustomer.map((item) => {
        selectedCustomer.push(item.value);
        return "";
      });
    }
    var selectedCustomers = selectedCustomer.length > 0 ? selectedCustomer.join(",") : "";

    var postObject = {
      broadcastTitle: postData.broadcastTitle,
      broadcastTemplateID: postData.whatsappTemplate?.value,
      broadcastSchedule: postData.broadcastSchedule !== "" ? format(postData.broadcastSchedule, "yyyy-MM-dd H:mm:00") : "",
      selectedCustomer: selectedCustomers,
      broadcastStatus: Object.keys(postData.status).length > 0 ? postData.status.value : "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"broadcast"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>

                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  customerList={this.state.customerList}
                  templateDetail={this.state.templateDetail}
                  whatsappTemplateList={this.state.whatsappTemplateList}
                  customersegmentList={this.state.customersegmentList}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { broadcastTitle, whatsappTemplate, /* selectedCustomer, */ status } = props.fields;
  return {
    fields: ["broadcastTitle", "whatsappTemplate" /* , "selectedCustomer" */, "status"],
    validations: {
      broadcastTitle: [[isEmpty, broadcastTitle]],
      whatsappTemplate: [[isSingleSelect, whatsappTemplate]],
      /* selectedCustomer: [[isCustomerSelect, selectedCustomer]], */
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      source: "",
      destination: "",
    };
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  changeSearch(name, e) {
    this.setState({ [name]: e.target.value });
  }

  sectCustomer(cust, type) {
    var updCust = this.props.fields.selectedCustomer;
    if (type === "add") {
      updCust.push(cust);
    } else if (type === "remove") {
      const index = updCust.indexOf(cust);
      updCust.splice(index, 1);
    }
    this.props.onChange("selectedCustomer", updCust);
  }
  checkingCust(currentCust, custLabel) {
    let selectedCustomer = this.props.fields.selectedCustomer;
    let updCustomer = [];
    selectedCustomer.map((item) => {
      updCustomer.push(item.value);
    });
    if (updCustomer.indexOf(currentCust) < 0) {
      var source = this.state.source;
      if (source !== "") {
        if (custLabel.toLowerCase().indexOf(source.toLowerCase()) >= 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  checkingSelectCust(custLabel) {
    var destination = this.state.destination;
    if (destination !== "") {
      if (custLabel.toLowerCase().indexOf(destination.toLowerCase()) >= 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  selectAll(type) {
    let customerList = type === "add" ? this.props.customerList : [];
    this.props.onChange("selectedCustomer", customerList);
  }

  handleCustType(typeTxt) {
    console.log("typeTxt", typeTxt);
    this.props.onChange("customersfromsegment", typeTxt);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgbroadcastTitle,
      errMsgwhatsappTemplate,
      errMsgselectedCustomer,
      errMsgStatus = "";
    if ($validation.broadcastTitle.error.reason !== undefined) {
      errMsgbroadcastTitle = $validation.broadcastTitle.show && <span className="error">{$validation.broadcastTitle.error.reason}</span>;
    }
    if ($validation.whatsappTemplate.error.reason !== undefined) {
      errMsgwhatsappTemplate = $validation.whatsappTemplate.show && <span className="error">{$validation.whatsappTemplate.error.reason}</span>;
    }
    /* if ($validation.selectedCustomer.error.reason !== undefined) {
      errMsgselectedCustomer = $validation.selectedCustomer.show && (
        <span className="error">
          {$validation.selectedCustomer.error.reason}
        </span>
      );
    } */

    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && <span className="error">{$validation.status.error.reason}</span>;
    }

    let templateDetailObj = this.props.templateDetail;

    console.log("WWWWHHH", this.props.customerList);

    return (
      <form className="card fv-plugins-bootstrap5 whatsapp-broadcast-frm" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgbroadcastTitle !== "" && errMsgbroadcastTitle !== false && errMsgbroadcastTitle !== undefined ? "form-control is-invalid" : "form-control"}
                name="broadcastTitle"
                value={fields.broadcastTitle}
                {...$field("broadcastTitle", (e) => onChange("broadcastTitle", e.target.value))}
              />
              <label htmlFor="broadcastTitle">
                Title <span className="error">*</span>
              </label>
              {errMsgbroadcastTitle}
            </div>
          </div>
          <div className={errMsgwhatsappTemplate !== "" && errMsgwhatsappTemplate !== false && errMsgwhatsappTemplate !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.whatsappTemplate}
                onChange={this.handleChange.bind(this, "whatsappTemplate")}
                placeholder="Select Template"
                options={this.props.whatsappTemplateList}
                isClearable={true}
              />
              <label className="select-box-label">
                Template<span className="error">*</span>
              </label>
              {errMsgwhatsappTemplate}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4 custm-date-box">
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                showTimeSelect
                dropdownMode="select"
                className="form-control"
                selected={fields.broadcastSchedule}
                timeIntervals={5}
                minDate={new Date()}
                dateFormat="dd/MM/yyyy h:mm aa"
                onChange={this.handleChange.bind(this, "broadcastSchedule")}
              />
              <label className="select-box-label">Schedule Date & Time</label>
            </div>
          </div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.status}
                onChange={this.handleChange.bind(this, "status")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-6 customer-segment-rediobtndiv">
            <label className="select-box-label">Select customers from customer segment ? &nbsp;&nbsp;</label>
            <input
              type="radio"
              id="customersfromsegment"
              name="customersfromsegment"
              value="Yes"
              checked={fields.customersfromsegment == "Yes" ? true : false}
              onChange={this.handleCustType.bind(this, "Yes")}
            />{" "}
            Yes &nbsp;&nbsp;
            <input
              type="radio"
              id="customersfromsegment"
              name="customersfromsegment"
              value="No"
              checked={fields.customersfromsegment == "No" ? true : false}
              onChange={this.handleCustType.bind(this, "No")}
            />{" "}
            No
          </div>
          <div className="col-md-6"></div>
          {fields.customersfromsegment == "Yes" && (
            <div className="col-md-6">
              <div className="form-floating form-floating-outline custm-select-box">
                <Select
                  value={fields.customersegmentId}
                  onChange={this.handleChange.bind(this, "customersegmentId")}
                  placeholder="Select Customer Segment"
                  options={this.props.customersegmentList}
                  isClearable={true}
                />
                <label className="select-box-label">Customer Segment</label>
              </div>
            </div>
          )}
          <div className="col-md-12 dual-listbox-main">
            <div className="dual-listbox">
              <div className="list-container">
                <input type="text" className="search" placeholder="Search..." value={this.state.source} onChange={this.changeSearch.bind(this, "source")} />
                {this.props.customerList.length > 0 && (
                  <ul className="list" id="list1">
                    {this.props.customerList.map((item, index) => {
                      const checkingCust = this.checkingCust(item.value, item.label);
                      if (checkingCust === true) {
                        return (
                          <li key={index} onClick={this.sectCustomer.bind(this, item, "add")}>
                            {item.label}
                          </li>
                        );
                      } else {
                        return "";
                      }
                    })}
                  </ul>
                )}
              </div>
              <div className="buttons">
                <button type="button" onClick={this.selectAll.bind(this, "add")} title="Select All">
                  →
                </button>
                <button type="button" onClick={this.selectAll.bind(this, "remove")} title="Remove All">
                  ←
                </button>
              </div>
              <div className="list-container">
                <input type="text" className="search" value={this.state.destination} placeholder="Search..." onChange={this.changeSearch.bind(this, "destination")} />
                <ul className="list" id="list2">
                  {fields.selectedCustomer.length > 0 &&
                    fields.selectedCustomer.map((item, index) => {
                      const checkingSelectCust = this.checkingSelectCust(item.label);
                      if (checkingSelectCust === true) {
                        return (
                          <li key={index} onClick={this.sectCustomer.bind(this, index, "remove")}>
                            {item.label}
                          </li>
                        );
                      }
                    })}
                </ul>
                {errMsgselectedCustomer}
              </div>
            </div>
          </div>

          {Object.keys(templateDetailObj).length > 0 && (
            <div className="row" style={{ marginTop: "15px" }}>
              <div className="col-md-3"></div>

              <div className="col-md-6">
                <div className="content-preview-header">
                  <h5>Message preview</h5>
                </div>
                <div className="content-preview-body">
                  <div className="whatsapptmpl-phone">
                    <div className="whatsapptmpl-top-bar">
                      <div className="whatsapptmpl-icon"></div>
                      <div className="whatsapptmpl-phone-number">Your phone number</div>
                    </div>
                    <div className="whatsapptmpl-screen">
                      {Object.keys(templateDetailObj.template_content_type).length > 0 && templateDetailObj.template_content_type.value == "Card" && (
                        <div className="whatsapptmpl-media-image">
                          <img className="whatsapptmpl-mediaimage" alt="" src={templateDetailObj.template_media_image} />
                        </div>
                      )}

                      <div className="whatsapptmpl-body">
                        <pre>{templateDetailObj.template_body_content}</pre>
                      </div>

                      {Object.keys(templateDetailObj.template_content_type).length > 0 && templateDetailObj.template_content_type.value == "Media" && (
                        <div className="whatsapptmpl-media-image">
                          <img className="whatsapptmpl-mediaimage" alt="" src={templateDetailObj.template_media_image} />
                        </div>
                      )}

                      {Object.keys(templateDetailObj.template_content_type).length > 0 && templateDetailObj.template_content_type.value == "Card" && (
                        <>
                          <div className="whatsapptmpl-footer">{templateDetailObj.template_footer_text}</div>

                          {templateDetailObj.template_button_text != "" && templateDetailObj.template_website_URL != "" && (
                            <a href={templateDetailObj.template_website_URL} target="_blank" className="template_website_button">
                              <i className="fa fa-external-link" aria-hidden="true"></i>
                              {templateDetailObj.template_button_text}
                            </a>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3"></div>
            </div>
          )}

          {fields.broadcastMsgStatus == "Pending" && (
            <div className="pt-1 pb-4 pt-1 text-end">
              <button
                type="button"
                className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>
              <Link to={modulePath}>
                <button type="reset" className="btn btn-label-secondary waves-effect">
                  Cancel
                </button>
              </Link>
            </div>
          )}
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
